/**
 * A wrapper for SimpleTimeSeriesGraph that uses Redux store for data
 */

import React, { useMemo } from "react";
import { useAppSelector } from "src/stores/redux/hooks";
import SimpleTimeSeriesGraph from "./time-series-graph-simple";
import { getStreamPreviewData } from "src/modules/flow-designer/react-flow/helpers/selectors";

interface TimeSeriesGraphWithStoreProps {
    series: {
        dataKey: string;
        name: string;
        color: string;
    }[];
    width?: number;
    height?: number;
    title?: string;
}

/**
 * A wrapper for SimpleTimeSeriesGraph that uses Redux store for data
 * This component will automatically update when the Redux store's data changes
 */
const TimeSeriesGraphWithStore: React.FC<TimeSeriesGraphWithStoreProps> = ({
    series,
    width = 800,
    height = 400,
    title
}) => {
    const data = useAppSelector(getStreamPreviewData);
    const graphData = useMemo(() => {
        return data.slice(-30).map(d => {
            return {
                actualValue: d.forecast.actualValue,
                predictedValue: d.forecast.predictedValue,
                timestamp: d.timeStamp
            };
        });
    }, [data]);

    return (
        <div>
            <SimpleTimeSeriesGraph data={graphData} series={series} width={width} height={height} title={title} />
        </div>
    );
};

export default TimeSeriesGraphWithStore;
